import React, { useState } from "react";
import { Trophy, Coins } from "lucide-react";
import useFetch from "@/lib/useFetch";
import { PageHeader, Footer } from "@/components/common/Page";
import Loader from "@/components/common/Loader";

export default function Leaderboards() {
    const { data: communities } = useFetch("/communities");
    const [filter, setFilter] = useState("ALL");
    const { data } = useFetch(filter === "ALL" ? "/leaderboards" : `/leaderboards?community_key=${filter}`, [filter]);
    if (!communities || !data) return <Loader />;
    const nameFor = (k) => communities.find((c) => c.key === k)?.name || k;
    const medal = ["#FFD700", "#C0C0C0", "#CD7F32"];

    return (
        <div data-testid="player-leaderboards">
            <PageHeader title="Leaderboards" subtitle="Top survivors ranked by wealth and activity." />
            <div className="flex flex-wrap gap-2 mb-4">
                {["ALL", ...communities.map((c) => c.key)].map((k) => (
                    <button key={k} onClick={() => setFilter(k)} data-testid={`lb-filter-${k}`}
                        className={`px-3 py-1.5 rounded-sm label-mono border ${filter === k ? "border-hazard text-hazard bg-hazard/10" : "border-border text-muted-foreground"}`}>
                        {k === "ALL" ? "ALL" : nameFor(k)}
                    </button>
                ))}
            </div>
            <div className="tactical-card rounded-lg overflow-x-auto">
                <table className="w-full text-sm">
                    <thead>
                        <tr className="border-b border-border text-left label-mono text-muted-foreground">
                            <th className="p-3 w-12">#</th><th className="p-3">Player</th>
                            <th className="p-3 hidden md:table-cell">Community</th>
                            <th className="p-3 text-right">Scrap</th><th className="p-3 text-right hidden sm:table-cell">Events</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((r, i) => (
                            <tr key={`${r.username}-${r.community_key}`} data-testid={`lb-row-${i}`} className="border-b border-border/60 hover:bg-accent/40">
                                <td className="p-3"><span className="font-heading text-lg font-bold" style={{ color: medal[i] || "#8B949E" }}>{i + 1}</span></td>
                                <td className="p-3">
                                    <div className="flex items-center gap-2">
                                        <img src={r.avatar || `https://api.dicebear.com/7.x/bottts/svg?seed=${r.username}`} className="h-7 w-7 rounded-md border border-border bg-background" alt="" />
                                        <span className="font-semibold text-foreground">{r.username}</span>
                                        {i < 3 && <Trophy size={14} style={{ color: medal[i] }} />}
                                    </div>
                                </td>
                                <td className="p-3 hidden md:table-cell text-muted-foreground">{nameFor(r.community_key)}</td>
                                <td className="p-3 text-right font-heading font-bold text-radioactive"><span className="inline-flex items-center gap-1"><Coins size={13} />{r.scrap.toLocaleString()}</span></td>
                                <td className="p-3 text-right hidden sm:table-cell text-foreground">{r.events}</td>
                            </tr>
                        ))}
                        {data.length === 0 && <tr><td colSpan={5} className="p-6 text-muted-foreground">No ranked players yet.</td></tr>}
                    </tbody>
                </table>
            </div>
            <Footer />
        </div>
    );
}
